"use strict";
var _a;
(_a = document.querySelector(".find-us-on button")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
    // @ts-ignore
    gtag('event', 'footer_takealot_click', {
        'app_name': 'ccd-store',
        'screen_name': 'home'
    });
    var url = "https://www.takealot.com/all?filter=Brand:Coffee%20capsules%20direct";
    window.open(url, "_blank");
});
